<template>
  <!-- 首页 第三块 -->
  <div class="mcont3">
    <div>
      <!-- <img src="@/assets/images/logo.png"> -->
      <div>
        <h1>
          {{title}}
        </h1><br>
        <span>We will provide you with the IT solutions you need to support your customers' growth strategies</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  computed: {
    title () {
      return this.$store.getters.currentLang === 'zh' ? '我们将为您提供支持客户成长战略所需的IT解决方案' : 'お客様の成長戦略をサポートするITソリューションをお届けします'
    }
  }
}
</script>

<style scoped lang="scss">
// 内容模块三
.mcont3 {
  margin-top: 38px;
  margin-bottom: 30px;
  width: 100%;
  height: 236px;
  background: url(../../assets/images/gold-bg.png) no-repeat;
  background-size: 100% 100%;
  > div {
    width: 960px;
    height: inherit;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    > div {
      // width: 960px;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      height: inherit;
      > h1 {
        // margin-top: 60px;
        color: $write;
      }
      > span {
        color: #bbbbbb;
      }
    }
  }
}
</style>


